import projection from '../generated/pwd204f1.json';
import { AcceptanceManifest } from '../types';
export const pwd204f1AcceptanceManifest = projection as AcceptanceManifest;
